const formatNumber = (number, digit = 2) => {
  const stringToNumber = Number(number);

  return stringToNumber?.toLocaleString('en-US', { maximumFractionDigits: digit }) ?? '0';
};

export default formatNumber;
